import { useMutation } from '@tanstack/react-query';
import { Sparkles, Trash2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { NoticeCard } from '@/components/ui/notice-card';
import { api } from '@/lib/utils';
import { useAuth } from '@/lib/auth';

export function DemoDataBanner() {
  const { user, refresh } = useAuth();
  const demoActive = Boolean(user?.settings?.demoSeedBatchId);

  const removeMutation = useMutation({
    mutationFn: () => api<{ removed: number }>('/api/v1/demo-data', { method: 'DELETE' }),
    onSuccess: async () => {
      await refresh();
      window.location.reload();
    },
  });

  if (!demoActive) return null;

  return (
    <NoticeCard
      icon={Sparkles}
      title="You're viewing sample customers"
      action={
        <Button
          variant="secondary"
          size="sm"
          loading={removeMutation.isPending}
          onClick={() => removeMutation.mutate()}
        >
          <Trash2 className="h-4 w-4" /> Remove sample data
        </Button>
      }
    >
      <p>
        These agreements and contacts are for exploring the product — not your real book. Remove everything with one
        click, then import your spreadsheet or connect Jobber, Housecall Pro, or QuickBooks in Settings.
      </p>
    </NoticeCard>
  );
}
